
import unescape from 'unescape'

// Converts html to plain string removing all the tags
const htmlToPlain = html => unescape(
  html
    .replace(/<br>/gm, '\n')
    .replace(/<\/?[^>]*>/gm, '')
)

export default htmlToPlain



// WEBPACK FOOTER //
// ./src/utils/htmlToPlain.js